module.exports = __webpack_public_path__ + "static/img/img_cabinet.43540780.png";